export default function CircularLoading() {
  return (
    <div className='relative h-4 w-4'>
      {[...Array(8)].map((_, i) => (
        <span
          key={i}
          className='animate-spinner-fade absolute inset-0 flex justify-center'
          style={{
            transform: `rotate(${i * 45}deg)`,
            animationDelay: `${i * 0.12}s`,
          }}
        >
          <span className='mt-0 h-[5px] w-[1px] rounded-full bg-[#878F9B]' />
        </span>
      ))}
    </div>
  );
}
